import { render, staticRenderFns } from "./liveControl.vue?vue&type=template&id=5f3d2044&scoped=true&"
import script from "./liveControl.vue?vue&type=script&lang=js&"
export * from "./liveControl.vue?vue&type=script&lang=js&"
import style0 from "./liveControl.vue?vue&type=style&index=0&id=5f3d2044&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d2044",
  null
  
)

export default component.exports